import type { App } from 'vue'

// Import base components
import BaseButton from '@/components/base-button.vue'
import BaseCheckbox from '@/components/base-checkbox.vue'
import BaseDropdown from '@/components/base-dropdown.vue'
import BaseInput from '@/components/base-input.vue'
import BaseModal from '@/components/base-modal.vue'
import BaseMultiSelect from '@/components/base-multi-select.vue'
import BaseTextarea from '@/components/base-textarea.vue'
import BaseToast from '@/components/base-toast.vue'
import BaseToggle from '@/components/base-toggle.vue'
import CopyButton from '@/components/copy-button.vue'
import DashboardAlerts from '@/components/dashboard-alerts.vue'
import LottieLoader from '@/components/lottie-loader.vue'
import PermissionErrorModal from '@/components/permission-error-modal.vue'
import ResponsiveWrapper from '@/components/responsive-wrapper.vue'
import TabButtons from '@/components/tab-buttons.vue'
import TabCard from '@/components/tab-card.vue'
import TabView from '@/components/tab-view.vue'
import TimelineEditor from '@/components/timeline-editor.vue'
import ToastNotification from '@/components/toast-notification.vue'
import ToolTip from '@/components/tool-tip.vue'
import TwoColumnLayout from '@/layouts/two-column-layout.vue'
import VotingEndedMessage from '@/components/voting-ended-message.vue'

const components = [
  { name: 'BaseButton', component: BaseButton },
  { name: 'BaseCheckbox', component: BaseCheckbox },
  { name: 'BaseDropdown', component: BaseDropdown },
  { name: 'BaseInput', component: BaseInput },
  { name: 'BaseModal', component: BaseModal },
  { name: 'BaseMultiSelect', component: BaseMultiSelect },
  { name: 'BaseTextarea', component: BaseTextarea },
  { name: 'BaseToast', component: BaseToast },
  { name: 'BaseToggle', component: BaseToggle },
  { name: 'CopyButton', component: CopyButton },
  { name: 'DashboardAlerts', component: DashboardAlerts },
  { name: 'LottieLoader', component: LottieLoader },
  { name: 'PermissionErrorModal', component: PermissionErrorModal },
  { name: 'ResponsiveWrapper', component: ResponsiveWrapper },
  { name: 'TabButtons', component: TabButtons },
  { name: 'TabCard', component: TabCard },
  { name: 'TabView', component: TabView },
  { name: 'TimelineEditor', component: TimelineEditor },
  { name: 'ToastNotification', component: ToastNotification },
  { name: 'ToolTip', component: ToolTip },
  { name: 'TwoColumnLayout', component: TwoColumnLayout },
  { name: 'VotingEndedMessage', component: VotingEndedMessage },
]

export default function registerComponents(app: App) {
  // Register each component globally
  components.forEach(({ name, component }) => {
    app.component(name, component)
  })
}
